import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL) {
  throw new Error("[VAULT_BOOT_FAILURE] Missing VITE_SUPABASE_URL.");
}

if (!SUPABASE_ANON_KEY) {
  throw new Error("[VAULT_BOOT_FAILURE] Missing VITE_SUPABASE_ANON_KEY.");
}

if (import.meta.env.DEV) {
  console.log("[Vault] Supabase URL:", SUPABASE_URL);
  console.log("[Vault] Anon key present:", Boolean(SUPABASE_ANON_KEY));
}

async function resilientFetch(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<Response> {
  try {
    return await fetch(input, init);
  } catch (err: any) {
    const message = err?.message ?? err?.toString?.() ?? "";

    const isTransient =
      message.includes("Failed to fetch") ||
      message.includes("NetworkError") ||
      message.includes("ERR_NETWORK_CHANGED");

    if (!isTransient) throw err;

    await new Promise((r) => setTimeout(r, 1200));
    return fetch(input, init);
  }
}

export const supabase = createClient(
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: "pkce",
    },
    global: {
      fetch: resilientFetch,
      headers: {
        "x-client-info": "paycalc-browser-thin-client",
      },
    },
    db: {
      schema: "public",
    },
  }
);

if (typeof window !== "undefined") {
  Object.assign(window, { supabase });
}